import { isNotDefined } from '@sgme/fp';

import { forwardAccumulatorApi } from '@/store/forwardAccumulator/api/index.ts';
import { forwardAccumulatorSlice } from '@/store/forwardAccumulator/slice.ts';
import type { StartAppListening } from '@/store/listenerMiddleware.ts';
import { duplicateTile } from '@/store/tiles/slice.ts';

export const registerDuplicateForwardAccumulatorTradeCaptureListeners = (startAppListening: StartAppListening) => {
  startAppListening({
    actionCreator: duplicateTile,
    effect: async (action, api) => {
      const state = api.getState();

      const sourceTile = forwardAccumulatorSlice.selectors.getForwardAccumulator(state, action.payload.sourceTileId);

      if (isNotDefined(sourceTile)) {
        return;
      }

      api.dispatch(
        forwardAccumulatorApi.endpoints.checkForwardAccumulator.initiate({
          ...sourceTile,
          properties: {
            ...sourceTile.properties,
            rfs: { status: 'CANCELLED' },
          },
          tileId: action.payload.newTileId,
        }),
      );
    },
  });
};
